import { CRORE, LAKH } from '../../../../../../utils/utils';
import { inrAmount } from '../../../../../../utils/formatters/inrAmount';
import type { EpfPayment } from '../../../../../../store/dashboard/compliancesBefe/types';
import { EPF_PAYMENT_STATUS_LABELS } from './constants';

export type EpfPaymentTone = 'onTime' | 'delayed' | 'default';

export const formatEmployees = (count: number): string => inrAmount(count);

/** ≥1 Cr → "2.10 Cr", ≥1 lakh → "34.43 lac", else en-IN rupees ("82,385"). */
export const formatLacCr = (amount: number): string => {
    if (amount >= CRORE) return `${(amount / CRORE).toFixed(2)} Cr`;
    if (amount >= LAKH) return `${(amount / LAKH).toFixed(2)} lac`;
    return inrAmount(Math.round(amount));
};

export const getPaymentTone = (payment: EpfPayment): EpfPaymentTone => {
    if (payment.isDefault) return 'default';
    return (payment.delayInDays ?? 0) > 0 ? 'delayed' : 'onTime';
};

export const formatPaymentStatus = (payment: EpfPayment): string => {
    const tone = getPaymentTone(payment);
    if (tone === 'default') return EPF_PAYMENT_STATUS_LABELS.DEFAULT;
    if (tone === 'onTime') return EPF_PAYMENT_STATUS_LABELS.ON_TIME;
    const days = payment.delayInDays as number;
    return `${days} ${days === 1 ? 'Day' : 'Days'} Delay`;
};
